import Helper from "Interfaces/Helper";


export function cardNumberClass(cardsPerSlide) {
    switch (cardsPerSlide) {
        case 1:
            return "show-one";
        case 2:
            return "show-two";
        case 3:
            return "show-three";
        case 4:
            return "show-fore";
        default:
            return "";
    }
}

export function getScreenSizes() {
    return {
        isMobile: window.matchMedia("(min-width: 0px)").matches,
        isTablet: window.matchMedia("(min-width: 768px)").matches,
        isLaptop: window.matchMedia("(min-width: 1024px)").matches,
        isDesktop: window.matchMedia("(min-width: 1300px)").matches,
        is1200Desktop: window.matchMedia("(min-width: 1200px)").matches
    }
}

export function calculateItemsNumber() {

    const { isMobile, isTablet, isDesktop, isLaptop } = getScreenSizes();

    if (isDesktop) return 5;
    if (isLaptop) return 4;
    if (isTablet) return 2;
    if (isMobile) return 1;
    return 1;
}

export function getEventCarouselType(carouselItems) {

    if (carouselItems.length === 0) return 'none';

    const firstCarouselItem = carouselItems[0];
    const { createDate, image, icon } = firstCarouselItem;

    if (Helper.getTimeValue(createDate) != -62135605254000) return "date"
    else if (image.url) return "image"
    else if (icon) return "icon"
    else return "none"
}
